import CheckbookConfiguration from 'src/sections/checkbook_configuration/ChechbookConfiguration';
import CheckbookConfigurationContextProvider from 'src/sections/checkbook_configuration/CheckbookConfigurationContext';

const ViewCheckbookConfiguration = () => (
  <CheckbookConfigurationContextProvider>
    <CheckbookConfiguration />
  </CheckbookConfigurationContextProvider>
);

export default ViewCheckbookConfiguration;
